import { useEffect, useState } from "react";
import UsersTable from "../components/UsersTable";
import Pagination from "./Pagination";
import { fetchBuyers } from "../services/adminUsersApi";
import Spinner from "../../../components/Spinner";

export default function AdminUsers() {
  const [buyers, setBuyers] = useState([]);
  const [pageInfo, setPageInfo] = useState(null);
  const [links, setLinks] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [page, setPage] = useState(0);
  const size = 10;

  useEffect(() => {
    loadUsers();
  }, [page]);

  const loadUsers = async () => {
    try {
      setLoading(true);

      const res = await fetchBuyers({ page, size });

      setBuyers(res.buyers);
      setPageInfo(res.page);
      setLinks(res.links);
    } catch (err) {
      setError("Failed to load users");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <>
        <Spinner text="Loading buyers..." />
      </>
    );
  }

  return (
    <>
      <UsersTable users={buyers} />

      {pageInfo && (
        <Pagination
          page={pageInfo.number}
          totalPages={pageInfo.totalPages}
          onPageChange={setPage}
        />
      )}
    </>
  );
}
